// Keyboard activation for elements styled as clickable rows (role="button").
// Native buttons fire on Enter and Space; mirror that for custom rows so the
// pickers are operable without a mouse.
export const onActivateKeyDown = (handler) => (e) => {
    if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handler();
    }
};

// Shared Tailwind classes for a keyboard-focusable row's focus ring.
export const FOCUS_RING = "focus:outline-none focus-visible:ring-2 focus-visible:ring-emp focus-visible:ring-offset-1";
